/**
 * Tutorial guidato dell'elenco Costi di spedizione.
 *
 * Il piu' in alto porta dritto alla pagina del nuovo costo. I tre pallini della
 * riga si raccontano illuminando il pulsante, non la voce dentro il menu. Aprire il menu
 * dal tutorial non e' affidabile: il click programmatico e il click su "Avanti"
 * arrivano a `document` a distanza di un soffio, e il menu appena aperto legge il
 * secondo come un click fuori e si richiude da solo. Il pulsante invece c'e'
 * sempre, e il testo dice cosa ci si trova dentro.
 *
 * I comandi massivi - Duplica, Modifica, Elimina - compaiono solo quando in alto
 * c'e' un metodo e un paese soli. Il tutorial non li fa comparire, perche' per
 * farlo dovrebbe scegliere due filtri al posto dell'utente e ricaricare l'elenco:
 * quel passo si aggancia ai comandi se sono gia' a schermo, altrimenti all'avviso
 * che spiega la stessa cosa.
 */
const SCOPE = '[data-tour-scope="shipping-costs"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

/** I comandi massivi se ci sono, altrimenti l'avviso che dice come farli comparire. */
function bulkTarget() {
	const bulk = document.querySelector(at('bulk'));

	return bulk && bulk.getClientRects().length > 0 ? bulk : document.querySelector(at('notice'));
}

/** Nessun preparativo: niente da rimettere a posto a fine giro. */
export function stopShippingCostsTour() {}

export function createShippingCostsTourSteps() {
	return [
		{
			body: "Questo e' il listino che il sito usa alla cassa: una riga per ogni combinazione di metodo, destinazione e fascia di peso, con il prezzo che il cliente si vede applicare. Se per una destinazione non c'e' nessuna riga, quel metodo alla cassa non compare.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'I costi di spedizione',
		},
		{
			body: "Il piu' in alto porta dritto alla pagina del nuovo costo: li' si scelgono metodo e destinazione e si scrivono gli scaglioni di peso, tutti in una volta. Annulla riporta qui con l'elenco come l'avevi lasciato. La pagina ha un tutorial suo.",
			key: 'add',
			placement: 'left',
			target: at('add'),
			title: 'Aggiungere un costo',
		},
		{
			body: "Metodi e Country restringono l'elenco, e accettano piu' scelte alla volta: sono il modo pratico per vedere solo il listino di un corriere o di un paese. Filtri, pagina e ordinamento restano nell'indirizzo: ricaricando o tornando da una scheda li ritrovi.",
			key: 'filters',
			placement: 'bottom',
			target: at('filters'),
			title: 'Filtrare il listino',
		},
		{
			body: "Scegliendo un metodo solo e un paese solo compaiono qui tre comandi che lavorano su tutte le righe filtrate: Duplica apre una pagina con le fasce copiate, da salvare su un'altra destinazione; Modifica apre una pagina per cambiarle in blocco; Elimina le cancella tutte, dopo una conferma. Agiscono su quello che hai filtrato, non su una riga.",
			key: 'bulk',
			placement: 'bottom',
			target: bulkTarget,
			title: 'I comandi massivi',
		},
		{
			body: "Qui si prova il listino prima che lo provi un cliente: scrivi un indirizzo, premi Cerca e Google lo scompone nei campi qui sotto; aggiungi il peso e premi Simula costo. La risposta e' l'elenco dei metodi con il prezzo, dal piu' economico in su: esattamente quello che vedrebbe chi ordina da quell'indirizzo.",
			key: 'test',
			placement: 'top',
			target: at('test'),
			title: 'Provare una spedizione',
		},
		{
			body: "La tabella mostra il metodo, la destinazione - paese con bandiera, e sotto la provincia o il cap se la tariffa vale solo li', altrimenti 'tutto il paese' - la fascia di peso, i giorni di consegna e il prezzo, 'Gratis' quando e' zero.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Leggere l’elenco',
		},
		{
			body: "I tre pallini a inizio riga aprono Modifica, che porta alla pagina della tariffa, ed Elimina, che chiede conferma. Lavorano su quella riga sola, senza toccare le altre dello stesso metodo.",
			key: 'row-menu',
			placement: 'right',
			target: at('row-menu'),
			title: 'Modificare una riga',
		},
		{
			body: "Il + accanto apre il riepilogo della tariffa e le altre fasce della stessa destinazione e metodo presenti nella pagina, disegnate su una barra dei pesi: si vede subito se fra una fascia e l'altra c'e' un buco o una sovrapposizione.",
			key: 'expand',
			missing: 'skip',
			placement: 'right',
			target: at('expand'),
			title: 'Riepilogo e fasce',
		},
		{
			body: "L'elenco arriva una pagina per volta dal server: da qui cambi pagina e quante righe vedere.",
			key: 'pagination',
			placement: 'top',
			target: `${SCOPE} .v-data-footer`,
			timeout: 400,
			title: "Sfogliare l'elenco",
		},
	];
}
